const Body = ({ children }) => {
  return (
    <div data-testid="body" className="pt-[80px]">
      {children}
    </div>
  );
};

export default Body;
